module.exports = __webpack_public_path__ + "img/telemarketer-icon.cb619239.png";